/**
 * Should the BOXED avatar stage key the live stream?
 *
 * A persona minted for Beam has a green backdrop in its live stream.
 * The Beam stage keys it; every other surface (launcher circle, rail
 * hero, PiP, sidebar) shows the raw stream — a green box (David,
 * Lumina 2026-09-04: "the button that expands to rail, both with
 * greenscreen"). Presence-wins keeps Beam pages on the Beam stage, but
 * a Beam-minted persona can still be deployed as a chat button or a
 * rail on purpose, so the boxed stage keys too — only when:
 *   - the server says this agent serves Beam (presentation boundless =
 *     Anam provider + plates; the persona IS green-minted), and
 *   - the current view is not Beam (the Beam stage already keys the
 *     same stream; two keyers on one stream is wasted GPU).
 * The keyer itself refuses non-green backdrops (keyability gate) and
 * returns null, so a studio-backdrop stream simply shows raw.
 */
export function shouldKeyLive(
  presentation: 'chrome' | 'boundless' | null | undefined,
  view: string | null | undefined,
  opts?: {
    /** The agent-led tour door (share.showpilot.com/t, /p). Carried for
        a door-specific rule later; today the door keys like any boxed
        view, because a Beam-served agent's PUBLISHED live face is the
        green-screen mint — un-keying it showed a green box on the door
        (prod, 2026-09-08 22:08 PT). The blurred-backdrop face needs a
        door-specific avatar id from the server, not a keying switch. */
    presentDoor?: boolean;
  },
): boolean {
  void opts;
  return presentation === 'boundless' && view !== 'unbound';
}
